import {
  getLiteralLanguage,
  getLiteralDirection,
  getLiteralType,
  getLiteralValue,
  IStringQuad,
  quadToStringQuad,
  stringQuadToQuad,
  stringToTerm,
  termToString,
} from './lib/TermUtil';
export {
  getLiteralLanguage,
  getLiteralDirection,
  getLiteralType,
  getLiteralValue,
  IStringQuad,
  quadToStringQuad,
  stringQuadToQuad,
  stringToTerm,
  termToString,
};
